export default {
  missingPeriodsLabel: 'Períodos faltantes',
  missingPeriodsDesc: '{count} períodos entre la primera y la última fecha de esta serie no tienen datos. Revisa que no falten filas.',
  shorterThanKpiLabel: 'Más corta que las ventas',
  shorterThanKpiDesc: 'Esta serie empieza después o termina antes que los datos de ventas. Está bien si no tuvo actividad en ese tiempo.',
  outlierLabel: 'Valores inusuales',
  outlierDesc: '{count} períodos están muy por encima o por debajo del nivel habitual de esta serie. Revisa errores de tipeo, ceros de más o una unidad distinta.',
  negativeLabel: 'Valores negativos',
  negativeDesc: '{count} filas tienen valores negativos.',
  zerosLabel: 'Ventas en cero',
  zerosDesc: '{count} períodos tienen ventas iguales a cero.',
  allZeroLabel: 'Solo ceros',
  allZeroDesc: 'Todos los valores de esta serie son cero.',
  constantLabel: 'Mismo valor',
  constantDesc: 'Esta serie tiene el mismo valor en todos los períodos. Revisa que no sea un valor de relleno.',
  mixedFrequencyLabel: 'Otra frecuencia',
  mixedFrequencyDesc: 'Esta serie tiene una frecuencia distinta (por ejemplo, mensual en vez de semanal) al resto de la hoja.',
  weekdayMismatchLabel: 'Fechas corridas',
  weekdayMismatchDesc: 'Algunas semanas de esta serie empiezan en un día distinto al del resto de la hoja, así que parte de sus datos podría estar corrida.',
  repeatedRowsLabel: 'Filas repetidas',
  repeatedRowsDesc: '{count} filas repiten la misma serie, fecha y dimensiones, así que sus valores se suman.'
}
